/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import announcementSvg from '../../../../public/announcements-ico.svg';
class ViewAnnouncements extends React.Component {

  render() {

    return (
      <div className="container pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">View / Edit Announcements</li>
          </ol>
        </nav>
        <div className="row bg-light p-3 mt-5 mb-3 rounded rounded-2 m-ver-col">
          <div className="col-12 mb-3 m-ancmtcard">
            <div className="card p-2 border-0 bg-transparent">
              <div className="row">
                <div className="col-1 text-end ancmtimg">
                  <img src={announcementSvg} className="mt-3" alt="announcement" />
                </div>
                <div className="col-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold text-dark">Name of the Mission wide announcement</h5>
                    <div className="announce-date">Date of Announcement : <b>24 October 2022</b></div>
                    <div className="row bg-white border border-1 p-2 mt-3 rounded rounded-3">
                      <div className="col-12">
                        <div className="domains mt-3">
                          <span className="text-muted dtit">Domians</span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Ayurveda</span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Homeopathy</span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Siddha</span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">Unani</span>
                        </div>
                        <p className="card-text mt-3 m-ancmnt-dec">
                          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis!  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis!
                        </p>
                        <div className="related-files mt-3">
                          <span className="text-muted dtit">Related Files</span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">File name 1 <i className="fa fa-file" aria-hidden="true"></i></span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">File name 2 <i className="fa fa-file" aria-hidden="true"></i></span>
                          <span className="badge bg-light text-dark p-2 px-4 rounded rounded-4">File name 3 <i className="fa fa-file" aria-hidden="true"></i></span>
                        </div>
                        <p className="card-text mt-4">
                          <a href="#" className="card-link fw-normal"><i className="fa fa-pencil" aria-hidden="true"></i> Edit Details</a>
                        </p>
                      </div></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewAnnouncements;